export const mapEmployeeProfileDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    title: dto.title,
    summary: dto.summary,
    birthDate: dto.birthDate,
    skills: dto.skills,
    sections: dto.sections,
});